import '../vendor/map-pin.css'
export default function MapPin(props: {
    lat: number;
    lng: number
}) {
    return <>
        <div className="pin"></div>
        <div className="pulse"></div>
    </>
}
